import { render, staticRenderFns } from "./SearchMainSection.vue?vue&type=template&id=58c81fcc"
import script from "./SearchMainSection.vue?vue&type=script&lang=js"
export * from "./SearchMainSection.vue?vue&type=script&lang=js"
import style0 from "./SearchMainSection.vue?vue&type=style&index=0&id=58c81fcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports